function timeAllowedLine(timeCell, fallbackTimed) {
  const raw = timeCell == null ? '' : String(timeCell).trim();
  if (!raw || raw.toLowerCase() === 'untimed') return 'Time allowed: Untimed';
  return `Time allowed: ${raw}`;
}

/**
 * Set-paper LNAT mock overview body (screenshot 1, Sample → Mock).
 * Not used for topic drills.
 */
export function buildLnatPearsonOverviewCopy({
  sectionACount,
  sectionBCount,
  paper1Time,
  paper2Time,
  untimed,
} = {}) {
  const aCount = Number(sectionACount) > 0 ? Number(sectionACount) : 42;
  const bCount = Number(sectionBCount) > 0 ? Number(sectionBCount) : 3;
  const timesUntimed = Boolean(untimed);
  const aTime = timesUntimed
    ? 'Time allowed: Untimed'
    : timeAllowedLine(paper1Time || '95 minutes');
  const bTime = timesUntimed
    ? 'Time allowed: Untimed'
    : timeAllowedLine(paper2Time || '40 minutes');
  const essayPhrase = bCount === 3 ? 'three essay questions' : `${bCount} essay questions`;

  return {
    title: 'National Admissions Test for Law (LNAT) Mock Test',
    intro: 'This test has two separate sections, A and B.',
    sectionAHeading: 'Section A : Multiple Choice',
    sectionABody: [
      'This section is divided into 12 subsections; each subsection has between 3 and 4 questions.',
      `You should answer all ${aCount} multiple choice questions in section A, selecting one of the possible answers listed for each question.`,
      `Once you have completed all ${aCount} questions, you will be presented with an Item Review Screen giving you the opportunity to review your responses. Once you are happy with your responses you should select 'End Review' and move to the next review screen.`,
    ],
    sectionATime: aTime,
    sfrHeading: 'Solution Feedback Review',
    sfrBody: [
      'This screen shows all questions and your response as correct or incorrect. You may not change your response.',
      "You may view solutions to each question by selecting the 'Explain Answer' button in the top left corner of the question.",
    ],
    sfrTime: 'Time allowed: Up to a maximum of 90 minutes',
    sectionBHeading: 'Section B : Essay',
    sectionBBody: [
      `This section has ${essayPhrase}.`,
      'You should select and answer one question in section B.',
    ],
    sectionBTime: bTime,
    sectionBNotes: [
      'There are no answers provided in this section.',
      'The LNAT is not looking for any factual knowledge about any of the essay topics.',
      'Only your ability to construct a reasoned and balanced argument, giving your arguments as well as acknowledging counter-arguments, is being tested.',
      'No marks are deducted for too many or too few words. We advise that 750 words is probably the maximum you could write in the time given. The quality of your argument is more important than the length of the essay.',
    ],
    note: 'Note: The timings in the mock test for Section A: Multiple Choice and Section B: Essay reflect the timings of the live test.',
    access: 'Additional time can be granted to candidates with examination access requirements. Please see the Exam Access Requirements page for more information.',
  };
}
